import React from "react";
// import { graphql } from "gatsby";

export default () => (
  <iframe
    width="100%"
    height="400"
    title="W.I.N. Multifamily Show"
    scrolling="no"
    frameborder="no"
    allow="autoplay"
    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/751817554&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=true"
  ></iframe>
);
